<div class="search-step" [formGroup]="form">
  <div class="search-input-wrapper">
    <ion-input
      #searchInput
      formControlName="query"
      [type]="isNativePlatform ? (isNumericKeyboard ? 'tel' : 'text') : 'text'"
      [placeholder]="'venta-rapida.search.placeholder' | translate"
      [clearInput]="true"
      class="search-input"
    />
    @if (isNativePlatform) {
    <button
      type="button"
      class="keyboard-toggle-button"
      (click)="toggleKeyboardType()"
      aria-label="Cambiar teclado"
    >
      <ion-icon
        [name]="isNumericKeyboard ? 'text-outline' : 'id-card-outline'"
        class="keyboard-icon"
      />
    </button>
    }
  </div>

  @if (isLoading() || isSearchPending()) {
  <div class="loading-container">
    <ion-spinner name="dots" />
  </div>
  } @if (hasNetworkError() && !isLoading()) {
  <div class="error-banner">
    <div class="error-text">
      <ion-icon name="alert-circle-outline" />
      <span>{{ "venta-rapida.search.error" | translate }}</span>
    </div>
    <button type="button" class="retry-button" (click)="retry()">
      {{ "venta-rapida.search.retry" | translate }}
    </button>
  </div>
  } @if (searchResults().length > 0) {
  <div class="results-list">
    @for (user of searchResults(); track user) {
    <app-user-search-result-item
      [user]="user"
      (selected)="onUserSelected($event)"
    />
    }
  </div>
  } @if (showNoResultsCard()) {
  <app-venta-rapida-no-results-card
    [query]="searchQuery()"
    [queryKind]="queryKind()"
    (anonymousChosen)="onAnonymousChosen($event)"
  />
  } @if (!isLoading() && !hasNetworkError() && searchQuery().trim().length ===
  0) {
  <div class="empty-hints">
    <div class="search-hint">
      <ion-icon name="information-circle-outline" class="search-hint__icon" />
      <p class="search-hint__text">
        {{ "venta-rapida.search.hint" | translate }}
      </p>
    </div>
    <div class="unpaid-notice">
      <ion-icon name="wallet-outline" class="unpaid-notice__icon" />
      <p class="unpaid-notice__text">
        {{ "venta-rapida.search.unpaid-notice" | translate }}
      </p>
    </div>
  </div>
  }
</div>
